<template>
  <NuxtLayout
    name="main-view"
    :hasBackButton="true"
    :headline="$t('dbc-contract')"
  >
    <div
      v-if="$route.query.update"
      class="grid grid-cols-card-layout gap-2xs max-tablet:flex max-tablet:flex-col"
    >
      <DbcBanner
        severity="success"
        :has-border="true"
        :message="$t('dbc-text-cancel-contract-success')"
        :life="5000"
        class="mb-xs"
        role="alert"
        aria-live="assertive"
        @life-end="removeUpdateQueryParam()"
      />
    </div>
    <div
      v-if="contract"
      class="grid grid-cols-card-layout max-tablet:flex max-tablet:flex-col gap-2xs gap-x-xs"
    >
      <Card :pt="specialCardPassThrough">
        <template #header
          >{{ $t('dbc-label-contract-number') }}:
          <span class="whitespace-nowrap font-semibold">{{
            contract.contractNumber
          }}</span>
          <span
            :class="`border-solid border rounded uppercase py-[2px] px-[4px] ml-auto ${contractStatusClasses} max-tablet:text-sm`"
          >
            {{ contract.status.description }}
          </span>
        </template>
        <template #content>
          <DbcBanner
            severity="info"
            :message="$t('dbc-text-cancel-contract')"
          />

          <NuxtLink
            v-if="!validTo"
            :to="getPagePath['contract-cancel']![locale]"
            :class="buttonSecondarySpecial"
          >
            {{ $t('dbc-btn-text-contract-terminate') }}
          </NuxtLink>
        </template>
      </Card>
      <div class="grid grid-row-3 row-column-2 row-span-2">
        <div class="flex flex-col gap-2xs">
          <Card :pt="simpleCardPassthrough">
            <template #title
              >{{ $t('dbc-label-contract-customer-since') }}
            </template>
            <template #subtitle>
              {{ dayjs(contract.validFrom).format('DD[.] MMMM YYYY') }}
            </template>
          </Card>
          <Card v-if="validTo" :pt="simpleCardPassthrough">
            <template #title>{{ $t('dbc-label-end-of-contract') }} </template>
            <template #subtitle>
              {{ validTo }}
            </template>
          </Card>
          <Card v-if="!validTo" :pt="simpleCardPassthrough">
            <template #title
              >{{ $t('dbc-label-contract-contract-duration') }}
            </template>
            <template #subtitle>
              {{
                dayjs(contract.durationOfContractTo).format('DD[.] MMMM YYYY')
              }}
            </template>
          </Card>
          <Card :pt="simpleCardPassthrough">
            <template #title
              >{{ $t('dbc-label-contract-opening-code') }}
            </template>
            <template #subtitle>
              {{ contract.attributes.customerPin.value }}
            </template>
          </Card>
        </div>
      </div>
      <Card v-if="!validTo" :pt="simpleCardPassthrough">
        <template #title
          >{{ $t('dbc-label-contract-notice-period') }}
        </template>
        <template #subtitle>
          {{ contract.attributes.terminationPeriodInDays.value }}
          {{ $t('dbc-text-days') }}
        </template>
      </Card>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import 'dayjs/locale/de'
import { useCustomerStore } from '../../../../stores/customer'
import Card from 'primevue/card'

const customerStore = useCustomerStore()
const { contract } = storeToRefs(customerStore)

const { locale } = useI18n()

dayjs.locale(locale.value)

const validTo = computed(() => {
  return contract.value?.validTo
    ? dayjs(contract.value.validTo).format('DD[.] MMMM YYYY')
    : ''
})

const contractStatusClasses = computed(() => {
  let classes = ''
  switch (contract.value?.status.value) {
    case 'active':
      classes = 'bg-success border-success text-success-high'
      break
    case 'blocked':
      classes = 'bg-attention border-attention text-attention-high'
      break
    case 'in_preparation':
      classes = 'bg-warn border-warn text-warn-high'
      break
  }
  return classes
})
</script>
